import { TEXTBOX } from 'skrit-web-framework/constantes';

export const FORMS = {
    ROLES: 1,
    MENUS: 2,
    TEMAS: 3,
    PERFIL: 4,
    DASHBOARD: 5,
    VERSIONES: 6,
    USUARIOS: 7,
    USUARIOS_WEB: 8,
    CLIENTES_FACTURACION: 9,
    MENUS_WEB: 10,
    ROLES_WEB: 11,
    VERSIONES_WEB: 12,
    IDIOMAS: 13,
    IDIOMAS_WEB: 14,
    TIPOS: 15,
    PERMISOS_LICENCIAS: 16,
    EVENTOS: 17,
    PERMISOS_WEB: 18,
    ASOCIADOS: 19,
    ASOCIADOS_ALMACENES: 20,
    LICENCIAS_WEB: 21,
    TEMAS_WEB: 22,
    PERMISOS_VERSIONES: 23,
    MARCAS_ARTICULOS: 24,
    ARTICUOS: 25,
    MARCAS_MOTOS: 25,
    MOTOS: 25,
    ARTICULOS: 26,
    MOTOS_ARTICULOS: 27,
    MODELOS_MOTOS: 28,
    ARTICULOS_MOTO: 29,
    MOTOS_ARTICULO: 30,
    IMPORTACION_BD: 31,
    MARCAS_ERP: 32,
    FAMILIAS_ARTICULOS: 33,
};

export const GRIDS = {
    ROLES: { id: 0, controller: '/Roles' },
    MENUS: { id: 1, controller: '/Menus' },
    MENUS_HELP: { id: 28, controller: '/Menus' },
    MENUS_PERMISOS: { id: 2, controller: '/MenusPermisos' },
    IDIOMAS: { id: 3, controller: '/Idiomas' },
    DASHBOARD: { id: 4, controller: '/MenuUsuarioDesk' },
    VERSIONES: { id: 5, controller: '/Versiones' },
    ALERTAS: { id: 6, controller: '/Alertas' },
    USUARIOS: { id: 7, controller: '/Usuarios' },
    USUARIOS_WEB: { id: 8, controller: '/UsuariosWeb' },
    MENUS_WEB: { id: 10, controller: '/MenuWeb' },
    MENUS_WEB_HELP: { id: 29, controller: '/MenuWeb' },
    ROLES_WEB: { id: 11, controller: '/RolesWeb' },
    VERSIONES_WEB: { id: 12, controller: '/Versiones' },
    IDIOMAS_WEB: { id: 13, controller: '/IdiomasWeb' },
    TIPOS: { id: 14, controller: '/TipoLicencias' },
    PERMISOS_LICENCIAS: { id: 15, controller: '/MenusPermisos' },
    EVENTOS: { id: 16, controller: '/Eventos' },
    MODULOS: { id: 22, controller: '/ModulosLicencias' },
    PERMISOS_WEB: { id: 23, controller: '/MenuWebPermisos' },
    ASOCIADOS: { id: 24, controller: '/Asociados' },
    ASOCIADOS_ALMACENES: { id: 25, controller: '/AsociadosAlmacenes' },
    TEMAS_WEB: { id: 27, controller: '/Temas' },
    PERFIL: { id: 28, controller: '/Usuarios' },
    PERMISOS_VERSIONES: { id: 29, controller: '/MenuVersionPermisos' },
    TEMAS: { id: 34, controller: '/Temas' },
    MARCAS_ARTICULOS: { id: 35, controller: '/MarcasArticulos' },
    ARTICULOS: { id: 36, controller: '/Articulos' },
    MARCAS_MOTOS: { id: 35, controller: '/MarcasMotos' },
    MOTOS: { id: 36, controller: '/Motos' },
    MOTOS_ARTICULOS: { id: 37, controller: '/MotosArticulos' },
    MODELOS_MOTOS: { id: 38, controller: '/ModelosMotos' },
    IMPORTACION_BD: { id: 39, controller: '/ImportacionBD' },
    MARCAS_ERP: { id: 40, controller: '/MarcasERP' },
    FAMILIAS_ARTICULOS: { id: 41, controller: '/FamiliaArticulos' },
};

export const AYUDAS = {
    ARTICULOS: {
        grid: GRIDS.ARTICULOS,
        Component: () => import('../ayudas/Articulos'),
    },
    ASOCIADOS: {
        grid: GRIDS.ASOCIADOS,
        Component: () => import('../ayudas/Asociados'),
    },
    ASOCIADOS_ALMACENES: {
        grid: GRIDS.ASOCIADOS_ALMACENES,
        Component: () => import('../ayudas/AsociadosAlmacenes'),
    },
    IDIOMAS: {
        grid: GRIDS.IDIOMAS,
        Component: () => import('../ayudas/Idiomas'),
    },
    IDIOMAS_WEB: {
        grid: GRIDS.IDIOMAS_WEB,
        Component: () => import('../ayudas/IdiomasWeb'),
    },
    MENUS: {
        grid: GRIDS.MENUS_HELP,
        Component: () => import('../ayudas/MenusWeb'),
    },
    MENUS_WEB: {
        grid: GRIDS.MENUS_WEB_HELP,
        Component: () => import('../ayudas/MenusWeb'),
    },
    MOTOS: {
        grid: GRIDS.MOTOS,
        Component: () => import('../ayudas/Motos'),
    },
    TEMAS: {
        grid: GRIDS.TEMAS,
        Component: () => import('../ayudas/Temas'),
    },
    TEMAS_WEB: {
        grid: GRIDS.TEMAS_WEB,
        Component: () => import('../ayudas/TemasWeb'),
    },
    USUARIOS_WEB: {
        grid: GRIDS.USUARIOS_WEB,
        Component: () => import('../ayudas/UsuariosWeb'),
    },
    MARCAS_MOTOS: {
        grid: GRIDS.MARCAS_MOTOS,
        Component: () => import('../ayudas/MarcasMotos'),
    },
    MARCAS_ARTICULOS: {
        grid: GRIDS.MARCAS_ARTICULOS,
        Component: () => import('../ayudas/MarcasArticulos'),
    },
    MODELOS_MOTOS: {
        grid: GRIDS.MODELOS_MOTOS,
        Component: () => import('../ayudas/ModelosMoto'),
    },
    MARCAS_ERP: {
        grid: GRIDS.MARCAS_ERP,
        Component: () => import('../ayudas/MarcasERP'),
    },
    FAMILIAS_ARTICULOS: {
        grid: GRIDS.FAMILIAS_ARTICULOS,
        Component: () => import('../ayudas/FamiliasArticulos'),
    },
};

export const FICHAS = {
    DASHBOARD: {
        Ficha: () => import('../fichas/DashboardDrawer'),
    },
    EVENTOS: {
        Ficha: () => import('../fichas/eventos/Eventos'),
        Consulta: () => import('../consultas/eventos/Eventos'),
    },
    IDIOMAS: {
        Ficha: () => import('../fichas/idiomas/Idiomas'),
        Consulta: () => import('../consultas/idiomas/Idiomas'),
    },
    IDIOMAS_WEB: {
        Ficha: () => import('../fichas/ecommerce/idiomas/IdiomasWeb'),
        Consulta: () => import('../consultas/ecommerce/idiomas/IdiomasWeb'),
    },
    MENUS: {
        Ficha: () => import('../fichas/menus/Menus'),
        Consulta: () => import('../consultas/menus/Menus'),
    },
    MENUS_WEB: {
        Ficha: () => import('../fichas/ecommerce/menus/MenusWeb'),
        Consulta: () => import('../consultas/ecommerce/menus/MenusWeb'),
    },
    PERFIL: {
        Ficha: () => import('../fichas/perfil/usuarios/Usuario'),
        Consulta: () => import('../consultas/perfil/Usuario'),
    },
    PERMISOS: {
        Ficha: () => import('../fichas/permisos/Permisos'),
    },
    PERMISOS_WEB: {
        Ficha: () => import('../fichas/ecommerce/permisos/PermisosWeb'),
    },
    PERMISOS_VERSIONES: {
        Ficha: () => import('../fichas/permisos/PermisosVersiones'),
    },
    ROLES: {
        Ficha: () => import('../fichas/roles/Roles'),
        Consulta: () => import('../consultas/roles/Roles'),
    },
    ROLES_WEB: {
        Ficha: () => import('../fichas/ecommerce/roles/RolesWeb'),
        Consulta: () => import('../consultas/ecommerce/roles/RolesWeb'),
    },
    TEMAS_WEB: {
        Ficha: () => import('../fichas/ecommerce/temas/TemasWeb'),
        Consulta: () => import('../consultas/ecommerce/temas/TemasWeb'),
    },
    USUARIOS: {
        Ficha: () => import('../fichas/usuarios/Usuarios'),
        Consulta: () => import('../consultas/usuarios/Usuarios'),
    },
    USUARIOS_WEB: {
        Ficha: () => import('../fichas/ecommerce/usuarios/UsuariosWeb'),
        Consulta: () => import('../consultas/ecommerce/usuarios/UsuariosWeb'),
    },
    VERSIONES_WEB: {
        Ficha: () => import('../fichas/ecommerce/versiones/VersionesWeb'),
        Consulta: () => import('../consultas/ecommerce/versiones/VersionesWeb'),
    },
    VERSIONES_LIN_WEB: {
        Ficha: () => import('../fichas/ecommerce/versiones/VersionesLinWeb'),
        Consulta: () =>
            import('../consultas/ecommerce/versiones/VersionesLinWeb'),
    },
    MARCAS_ARTICULOS: {
        Ficha: () => import('../fichas/ecommerce/articulos/MarcasArticulos'),
        Consulta: () =>
            import('../consultas/ecommerce/articulos/MarcasArticulos'),
    },
    ARTICULOS: {
        Ficha: () => import('../fichas/ecommerce/articulos/Articulos'),
        Consulta: () => import('../consultas/ecommerce/articulos/Articulos'),
    },
    MARCAS_MOTOS: {
        Ficha: () => import('../fichas/ecommerce/motos/MarcasMotos'),
        Consulta: () => import('../consultas/ecommerce/motos/MarcasMotos'),
    },
    MOTOS: {
        Ficha: () => import('../fichas/ecommerce/motos/Motos'),
        Consulta: () => import('../consultas/ecommerce/motos/Motos'),
    },
    MOTOS_ARTICULOS: {
        // Ficha: () => import('../fichas/ecommerce/motos/Motos'),
        // Consulta: () => import('../consultas/ecommerce/motos/Motos')
    },
    MODELOS_MOTOS: {
        Consulta: () => import('../consultas/ecommerce/motos/ModelosMotos'),
        Ficha: () => import('../fichas/ecommerce/motos/ModelosMotos'),
    },
    ARTICULOS_MOTO: {
        Consulta: () => import('../consultas/ecommerce/motos/ArticulosMoto'),
        Ficha: () => import('../fichas/ecommerce/motos/ArticulosMoto'),
    },
    ARTICULO_MOTO: {
        Ficha: () => import('../fichas/ecommerce/motos/ArticuloMoto'),
    },
    MOTOS_ARTICULO: {
        Consulta: () =>
            import('../consultas/ecommerce/articulos/MotosArticulo'),
        Ficha: () => import('../fichas/ecommerce/articulos/MotosArticulo'),
    },
    MOTO_ARTICULO: {
        Ficha: () => import('../fichas/ecommerce/articulos/MotoArticulo'),
    },
    CSV: {
        Ficha: () => import('../fichas/Csv'),
    },
    CARGAR_MOTOS_CSV: {
        Ficha: () => import('../fichas/catalogo/importacion/CargarMotosCSV'),
    },
    CARGAR_ARTICULOS_CSV: {
        Ficha: () =>
            import('../fichas/catalogo/importacion/CargarArticulosCSV'),
    },
    CARGAR_MOT_ART_CSV: {
        Ficha: () => import('../fichas/catalogo/importacion/CargarMotArtCSV'),
    },
    CLIENTES: {
        Consulta: () => import('../consultas/usuarios/Clientes'),
    },
    CENTROS: {
        Consulta: () => import('../consultas/Centros'),
    },
    FAMILIAS_ARTICULOS: {
        Consulta: () =>
            import('../consultas/ecommerce/familias/FamiliasArticulos'),
        Ficha: () => import('../fichas/ecommerce/familias/FamiliasArticulos'),
    },
    EDITAR_MARCAS_MOTO: {
        Ficha: () => import('../fichas/catalogo/importacion/EditarMarcasMotos'),
    },
    EDITAR_MARCAS_ARTICULOS: {
        Ficha: () =>
            import('../fichas/catalogo/importacion/EditarMarcasArticulos'),
    },
    EDITAR_FAMILIAS_ARTICULOS: {
        Ficha: () =>
            import('../fichas/catalogo/importacion/EditarFamiliasArticulos'),
    },
};

export const REMOTE = {};

export const ICONOS = {
    DOC: 'ms-Icon ms-Icon--WordDocument icon-lg2',
    XLS: 'ms-Icon ms-Icon--ExcelDocument icon-lg2',
    PDF: 'ms-Icon ms-Icon--PDF icon-lg2',
    ZIP: 'fa fa-file-archive-o',
    WMV: 'fa fa-film',
    JPG: 'ms-Icon ms-Icon--FileImage icon-lg2',
    XLSX: 'ms-Icon ms-Icon--ExcelDocument icon-lg2',
    PPS: 'ms-Icon ms-Icon--PowerPointDocument icon-lg2',
    PPTX: 'ms-Icon ms-Icon--PowerPointDocument icon-lg2',
    DOCX: 'ms-Icon ms-Icon--WordDocument icon-lg2',
    TXT: 'ms-Icon ms-Icon--WordDocument icon-lg2',
    PPT: 'ms-Icon ms-Icon--PowerPointDocument icon-lg2',
    XLSM: 'ms-Icon ms-Icon--ExcelDocument icon-lg2',
    HTM: 'fa fa-file-code-o',
    MOV: 'fa fa-film',
    '3GP': 'fa fa-file-o',
    PNG: 'ms-Icon ms-Icon--FileImage icon-lg2',
    RTF: 'ms-Icon ms-Icon--WordDocument icon-lg2',
    CSV: 'ms-Icon ms-Icon--ExcelLogo icon-lg2',
};

export const EXTENSIONES_BYTES = [
    'jpg',
    'jpeg',
    'gif',
    'png',
    'bmp',
    'ico',
    'svg',
    'pdf',
];

export const headersRespuestaCsv = [
    {
        label: 'Linea',
        type: TEXTBOX.TEXT,
        key: 'Linea',
        width: 90,
    },
    {
        label: 'Error',
        type: TEXTBOX.TEXT,
        key: 'MsgError',
        width: 0,
        flexGrow: 1,
    },
];

export const ROLES = {
    MOSTRADOR: 'S1',
    CLIENTE: 'S2',
};

export const ROLES_ID = {
    MOSTRADOR: 1,
    CLIENTE: 7,
};
